module.exports = __webpack_public_path__ + "img/icon-cart.9930c7a0.svg";